import { FC, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as ThreeDotsIcon } from "images/ThreeDots.svg";
import { ReactComponent as TrashCan } from "images/TrashCan.svg";
import { DeletingLine } from "pages/StepPages/StepTwo/BusinessProcesses/DeletingLine/DeletingLine";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { convertDate } from "helpers";
import { PAGINATION_COUNT_STEP_THREE } from "constant";
import { ChoosingDate } from "components-new/ChoosingDate/ChoosingDate";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import { DeactivateEnumListStatus } from "toolkit/steps/stepThree/stepThree.slice";
import { createDeadline, deleteObject } from "toolkit/steps/stepThree/stepThree.thunk";
import styles from "./ObjectListTableItem.module.sass";
import cn from "classnames";

interface ObjectListTableItemProps {
	object: any;
	number: number;
}

interface IModalWindow {
	content: React.ReactElement | null;
	visibility: boolean;
}

export const ObjectListTableItem: FC<ObjectListTableItemProps> = ({ object, number }) => {
	const { currentEnumList, lastPart } = useAppSelector((state) => state.stepThree);
	const dispatch = useAppDispatch();
	const [modalWindow, setModalWindow] = useState<IModalWindow>({
		content: null,
		visibility: false,
	});
	const { organizationId } = useParams();
	const [menu, setMenu] = useState<boolean>(false);
	const menuRef = useRef(null);

	useOutsideAlerter(menuRef.current, () => setMenu(false));

	const deadlineHandler = (date: string) => {
		dispatch(
			createDeadline({
				objectId: object.id,
				date,
				deactivateStatus,
			}),
		);
	};

	const openMenu = () => {
		if (menu) return;
		setTimeout(() => {
			setMenu((prev) => !prev);
		}, 1);
	};

	const openModalWindow = (component: React.ReactElement) => {
		setModalWindow({ ...modalWindow, content: component, visibility: true });
		setMenu(false);
	};

	const closeModalWindow = () => {
		setModalWindow({ ...modalWindow, content: null, visibility: false });
	};

	const deleteHandler = () => {
		dispatch(
			deleteObject({
				objectId: object.id,
				enumListId: Number(currentEnumList?.id),
				part: lastPart,
				quantity: PAGINATION_COUNT_STEP_THREE,
				deactivateStatus,
			}),
		);
	};

	const deactivateStatus = () => {
		if (currentEnumList?.newestDocApprovalDate) dispatch(DeactivateEnumListStatus());
	};

	return (
		<>
			{modalWindow.visibility && <ModalWindow close={closeModalWindow}>{modalWindow.content}</ModalWindow>}
			<tr className={styles.row}>
				<td className={styles.cell}>{number + 1}</td>
				<td className={styles.cell}>
					<Link
						to={`/categorization/organizations/${organizationId}/steps/3.1/info`}
						state={{ id: object.obj.id, name: object.name }}
						className={styles.link}>
						{object.obj.objectName}
					</Link>
				</td>
				<td className={styles.cell}>{object.obj?.objectType?.name}</td>
				<td className={styles.cell}>{object.obj?.activity?.name}</td>
				<td
					onClick={() =>
						openModalWindow(
							<ChoosingDate
								title="Выбрать планируемый срок категорирования"
								subtitle="Число до которого процесс должен быть завершен"
								defaultDate={object.categorizationPlanEndDate || ""}
								onSubmit={deadlineHandler}
								close={closeModalWindow}
							/>,
						)
					}
					className={cn(styles.cell, styles["cell-date"])}>
					{object.categorizationPlanEndDate ? convertDate(object.categorizationPlanEndDate) : "Выберите дату"}
				</td>
				<td className={styles.cell}>
					<Link to={`/employee/${object.obj.responsible.id}`} className={styles.link}>
						{object.obj.responsible.lastName} {object.obj.responsible.firstName} {object.obj.responsible.middleName}
					</Link>
					<button onClick={openMenu} className={styles["menu-btn"]}>
						<ThreeDotsIcon />
					</button>
					<div ref={menuRef} className={styles["menu-wrp"]}>
						{menu && (
							<div onClick={(e) => e.stopPropagation()} className={cn(styles.menu)}>
								<div
									onClick={() =>
										openModalWindow(
											<DeletingLine
												close={closeModalWindow}
												closeAll={closeModalWindow}
												toDelete={deleteHandler}
												title={"Удалить строку?"}
											/>,
										)
									}
									className={styles.btn}>
									<div className={styles["icon-wrp"]}>
										<TrashCan className={styles.trashCan} />
									</div>
									<span className={styles["btn-txt"]}>Удалить элемент списка</span>
								</div>
							</div>
						)}
					</div>
				</td>
			</tr>
		</>
	);
};
